import React, { useEffect, useMemo, useState } from 'react';
import { Form, Input, Button, DatePicker, Row, Col, Dropdown, List, Spin, Select, Checkbox } from 'antd';
import { checkHasCar, completedTasks, getAllCarsForTasks, getCarsModels } from '../../app/api';
import { debounce } from '../../helpers/helpers';

const { Option } = Select;

const AddForm = () => {
  const [form] = Form.useForm();
  const [carData, setCarData] = useState([]);
  const [carSearch, setCarSearch] = useState("");
  const [carResults, setCarResults] = useState([]);
  const [carName, setCarName] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [allModels, setAllModels] = useState([]);
  const [isBtnDiasabled, setIsBtnDiasabled] = useState(false);
  const [isHasCar, setIsHasCar] = useState(false);
  const [products, setProducts] = useState([{ id: Date.now(), name: '', cost: '', price: '' }]);

  const addProduct = () => {
    setProducts([...products, { id: Date.now(), name: '', cost: '', price: '', count: 1 }]);
  };

  const removeProduct = (id) => {
    setProducts(products.filter((product) => product.id !== id));
  };

  const serviceTypes = [
    "Շարժիչի վերանորոգում",
    "Յուղի փոխարինում",
    "Տրանսմիսիոն համակարգի սպասարկում",
    "Էլեկտրական համակարգի սպասարկում",
    "Սարքավորման և էլեկտրոնիկայի վերանորոգում",
    "Անիվների ու դիսկերի վերանորոգում",
    "Բենզինային կամ դիզելային շարժիչների մաքրման և սպասարկում",
    "Ամորտիզացիոն համակարգի վերանորոգում",
    "Կիրառական մասերի պարբերական սպասարկում"
  ];

  const handleProductChange = (index, field, value) => {
    const updatedProducts = [...products];
    updatedProducts[index] = { ...updatedProducts[index], [field]: value };
    setProducts(updatedProducts);
  };

  const onFinish = async (values) => {
    setIsBtnDiasabled(true);
    try {
      const car_data = JSON.parse(values.cars);
      
      const taskData = {
        totalAmount: parseFloat(values.amount),
        date: values.date ? values.date.format('YYYY-MM-DD HH:mm:ss') : '',
        username: values.customerName || car_data.username,
        mobile: values.phoneNumber || car_data.user_mobile_number,
        car_id: car_data.id,
        work_name: values.jobName.filter(name => name.trim() !== ""),
        auto_name: values.carName,
        car_number: values.licensePlate.toUpperCase(),
        description: values.completedJob,
        ...(typeof values.licensePlate === 'object' ? { car_id: values.licensePlate.id } : {}),
        products: Array.isArray(products)
        ? products
            .filter(product => product.name?.trim() !== '' && product.cost != null)
            .map(product => ({
              name: product.name,
              cost: parseFloat(product.cost),
              price: product.price ? parseFloat(product.price) : undefined,
              count: product.count,
            }))
        : [],
      };
      
      try {
        const response = await completedTasks(taskData);
        if (response.status === 201) {
          form.resetFields();
          window.location.href = '/done'
        }
      } catch (error) {
        console.error('Error submitting task:', error);
      }
    } catch(err) {
      console.log("Error", err)
    } finally {
      setIsBtnDiasabled(false);
    }
  };

  const handleSearch = useMemo(
    () =>
      debounce(async (value) => {
        if (!value) {
          setCarResults([]);
          return;
        }
  
        setIsLoading(true);
        try {
          const response = await checkHasCar(value);
          if (response.data.success) {
            const carData = response.data.data;
            setCarResults(carData.length > 0 ? carData : []);
          }
        } catch (error) {
          console.error("Error during search:", error);
        }
        setIsLoading(false);
      }, 500),
    []
  );

  const handleCarChange = (car) => {
    const data = JSON.parse(car);
    if (data) {
      form.setFieldsValue({ 
        licensePlate: data.car_number, 
        carName: data.make,
        customerName: data.username,
        phoneNumber: data.user_mobile_number
      });
    }
    
  }

  useEffect(() => {
    const fetchInitialData = async () => {
      setIsLoading(true);
      try {
        const [modelsResponse, carsResponse] = await Promise.all([
          getCarsModels(),
          getAllCarsForTasks(carSearch),
        ]);

        if (modelsResponse.status === 200) {
          setAllModels(modelsResponse.data.data);
        }

        if (carsResponse.status === 200) {
          setCarData(carsResponse.data);
        }
      } catch (err) {
        console.error("Error loading initial data", err);
      } finally {
        setIsLoading(false);
      }
    };

    fetchInitialData();
  }, []);

  return (
    <div style={{ maxWidth: '800px', margin: '0 auto', padding: '20px' }}>
      <h2 style={{ textAlign: 'center' }}>Ավելացնել Աշխատանք</h2>
      <Form
        form={form}
        layout="vertical"
        onFinish={onFinish}
        initialValues={{
          customerName: '',
          phoneNumber: '',
          jobName: '',
          carName: '',
          cars: {},
          licensePlate: '',
          completedJob: '',
          amount: '',
          date: null,
        }}
      >
        {!isHasCar ? <Form.Item
          label="Մեքենաները"
          name="cars"
          rules={[{ required: true, message: 'Խնդրում ենք մեքենան' }]}
        >
          <Select
            showSearch
            placeholder="Ընտրել մեքենա"
            optionFilterProp="children"
            onSearch={handleSearch}
            notFoundContent={isLoading ? <Spin size="small" /> : null}
            onChange={handleCarChange}
          >
            {carData.map((item) => (
              <Option key={item.id} value={JSON.stringify(item)}>
                {item.username} ({item.car_number})
              </Option>
            ))}
          </Select>
        </Form.Item> : null}

        <Form.Item name="isCarRegistered" valuePropName="checked">
              <Checkbox
                  onChange={(e) => {
                      setIsHasCar(e.target.checked);
                      if (!e.target.checked) {
                          form.setFieldsValue({
                              customerName: '',  
                              mobile: '',   
                          });
                      }
                  }}
              >
                  Մեքենան գրանցվա՞ծ է պահեստում
              </Checkbox>
        </Form.Item>

        {isHasCar ? <div
          style={{
            marginBottom: '20px',
            padding: '15px',
            border: '1px solid #d9d9d9',
            borderRadius: '8px',
            backgroundColor: '#fafafa',
          }}
        >
          <h3 style={{ marginBottom: '15px' }}>Հաճախորդի Տվյալներ</h3>
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                label="Անուն Ազգանուն"
                name="customerName"
                rules={[
                  { required: false, message: 'Խնդրում ենք մուտքագրել անունը' },
                ]}
              >
                <Input placeholder="Մուտքագրեք անունը" />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                label="Հեռախոսահամար"
                name="phoneNumber"
                rules={[
                  {
                    required: false,
                    message: 'Խնդրում ենք մուտքագրել հեռախոսահամարը',
                  },
                  {
                    pattern: /^[0-9]{8,12}$/,
                    message: 'Մուտքագրեք վավեր հեռախոսահամար',
                  },
                ]}
              >
                <Input placeholder="Մուտքագրեք հեռախոսահամարը" />
              </Form.Item>
            </Col>
          </Row>
        </div> : null}

        <Form.Item
          label="Աշխատանքի Անունը"
          name="jobName"
          rules={[{ required: true, message: 'Խնդրում ենք մուտքագրել աշխատանքի անունը' }]}
        >
          <Select
            mode="multiple"
            style={{ width: '100%' }}
            placeholder="Ընտրեք սպասարկման տեսակները"
            allowClear
          >
            {serviceTypes.map((service, index) => (
              <Option key={index} value={service}>
                {service}
              </Option>
            ))}
          </Select>
        </Form.Item>

        <Form.Item
          label="Մեքենայի տեսակը"
          name="carName"
          rules={[{ required: true, message: 'Խնդրում ենք մուտքագրել մեքենայի անունը' }]}
        >
          <Select
            showSearch
            placeholder="Ընտրել արտադրող"
            optionFilterProp="children"
            filterOption={(input, option) =>
              option?.children.toLowerCase().includes(input.toLowerCase())
            }
          >
            {allModels.map((item) => (
              <Option key={item.id} value={item.brand}>
                {item.brand}
              </Option>
            ))}
          </Select>
        </Form.Item>

        <Form.Item
          label="Պետհամարանիշ"
          name="licensePlate"
          rules={[{ required: true, message: 'Խնդրում ենք մուտքագրել պետհամարանիշը' }]}
          normalize={(value) => value?.toUpperCase().replace(/[^A-Z0-9]/g, '').slice(0, 8)}
        >
          <Input placeholder="Մեքենայի համարանիշ" />
        </Form.Item>

        <Form.Item
          label="Կատարված Աշխատանքը"
          name="completedJob"
          rules={[
            { required: true, message: 'Խնդրում ենք մուտքագրել կատարված աշխատանքը' },
            {
              validator: (_, value) => {
                if (value && value.length > 65000) {
                  return Promise.reject('Տեքստը գերազանցում է 65000 նիշը');
                }
                return Promise.resolve();
              }
            }
          ]}
        >
          <Input.TextArea rows={4} placeholder="Մուտքագրեք կատարված աշխատանքը" />
        </Form.Item>

        <div
          style={{
            marginBottom: '20px',
            padding: '15px',
            border: '1px solid #d9d9d9',
            borderRadius: '8px',
            backgroundColor: '#fafafa',
          }}
        >
          <Form.Item>
            {products.map((product, index) => (
              <Row key={product.id} gutter={16} align="middle" style={{ marginBottom: 10 }}>
                <Col span={5}>
                  <Form.Item
                    label="Անուն"
                    name={`name-${product.id}`}
                    rules={[
                      {
                        validator: (_, value) => {
                          const { cost, count } = product;
                          if (value || cost || count) {
                            return value ? Promise.resolve() : Promise.reject('Անունը պարտադիր է');
                          }
                          return Promise.resolve();
                        },
                      },
                    ]}
                  >
                    <Input 
                      placeholder="Ապրանքի անուն" 
                      value={products.name}
                      onChange={(e) => handleProductChange(index, 'name', e.target.value)}
                    />
                  </Form.Item>
                </Col>
                <Col span={5}>
                  <Form.Item  
                    label="Ինքնարժեք"
                    name={`cost-${product.id}`}
                    // rules={[
                    //   {
                    //     validator: (_, value) => {
                    //       const { name, count } = product;
                    //       if (value || name || count) {
                    //         return value ? Promise.resolve() : Promise.reject('Ինքնարժեքը պարտադիր է');
                    //       }
                    //       return Promise.resolve();
                    //     },
                    //   },
                    // ]}
                  >
                    <Input 
                      type="number" 
                      placeholder="Ինքնարժեք"
                      value={product.cost}
                      onChange={(e) => handleProductChange(index, 'cost', e.target.value)}
                    />
                  </Form.Item>
                </Col>
                <Col span={5}>
                  <Form.Item
                    label="Վաճառված Գին"
                    name={`price-${product.id}`}
                  >
                    <Input 
                      type="number" 
                      placeholder="Վաճառված գին"
                      value={product.price}
                      onChange={(e) => handleProductChange(index, 'price', e.target.value)}
                    />
                  </Form.Item>
                </Col>
                <Col span={5}>
                  <Form.Item
                    label="Քանակը"
                    name={`count-${product.id}`}
                    rules={[
                      {
                        validator: (_, value) => {
                          const { name, cost } = product;
                          if (value || name || cost) {
                            return value ? Promise.resolve() : Promise.reject('Քանակը պարտադիր է');
                          }
                          return Promise.resolve();
                        },
                      },
                    ]}
                  >
                    <Input 
                      type="number" 
                      placeholder="Քանակը"
                      value={product.count}
                      onChange={(e) => handleProductChange(index, 'count', e.target.value)}
                    />
                  </Form.Item>
                </Col>
                <Col span={4}>
                  <Button danger onClick={() => removeProduct(product.id)} disabled={products.length === 1}>
                    ✖
                  </Button>
                </Col>
              </Row>
            ))}
            <Button type="dashed" onClick={addProduct} block>
              ➕ Ավելացնել Ապրանք
            </Button>
          </Form.Item>
        </div>

         <Form.Item
            label="Աշխատանքի Գումար"
            name="amount"
            rules={[{ required: true, message: 'Խնդրում ենք լրացնել գումարը' }]}
        >
            <Input type="number" placeholder="Օրինակ՝ 5000" />
        </Form.Item>

        <Form.Item
            label="Ամսաթիվ"
            name="date"
            rules={[{ required: true, message: 'Խնդրում ենք ընտրել ամսաթիվը' }]}
        >
            <DatePicker 
                showTime
                format="YYYY-MM-DD HH:mm:ss"
                placeholder="Ընտրեք ամսաթիվը"
                style={{ width: '100%' }}
            />
        </Form.Item>

        <Form.Item>
          <Button type="primary" htmlType="submit" block disabled={isBtnDiasabled}>
            Ավելացնել
          </Button>
        </Form.Item>
      </Form>
    </div>
  );
};

export default AddForm;
